import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { CheckoutForm } from './checkoutForm';
import { loadStripe } from '@stripe/stripe-js';

export const StipeCard = () => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PKEY);

    return (
        <div className="stripe-card-box">
            <Elements stripe={stripePromise}>
                <CheckoutForm />
            </Elements>
        </div>
    );
};
